import { Valence } from '@upright/common/model/types';
import { equalInfoBoxesLayout } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/info-boxes/equal-info-boxes-layout';
import {
  CarouselLayout,
  LensBoxMode,
  Side,
} from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { LeftAndRightImpactSelectionState } from '@upright/ui/common/upright/core/impact-lens-profile/selection-state/separate-left-right-selection-state';
import { ClientDatum, ClientDatumInfoBoxData, ClientDatumInfoBoxDataWithBounds } from './types';
import { getClientDatumInfoBoxes } from './get-client-datum-info-boxes';

export function clientDatumInfoBoxDataWithBoundsForSelection<T extends ClientDatum>(
  baseLayout: CarouselLayout,
  data: T[],
  lensIndex: number,
  previousLensIndex: number | undefined,
  selection: LeftAndRightImpactSelectionState | undefined,
): Array<ClientDatumInfoBoxDataWithBounds<T>> {
  const modalMode = baseLayout.boxMode === LensBoxMode.MODAL;
  const filteredData = data.filter(d => {
    if (!selection) {
      if (!modalMode) {
        return true;
      }
      return false;
    }
    if (d.valence === Valence.NEGATIVE && (!modalMode || selection.lastSide === Side.LEFT)) {
      return !selection.left || selection.left === d.impactCategoryId;
    }
    if (d.valence === Valence.POSITIVE && (!modalMode || selection.lastSide === Side.RIGHT)) {
      return !selection.right || selection.right === d.impactCategoryId;
    }
    return false;
  });
  const maxBoxes = modalMode ? 1 : 3;
  return clientDatumInfoBoxDataWithBounds(baseLayout, filteredData, lensIndex, previousLensIndex, maxBoxes);
}

function clientDatumInfoBoxDataWithBounds<T extends ClientDatum>(
  baseLayout: CarouselLayout,
  data: T[],
  lensIndex: number,
  previousLensIndex: number | undefined,
  maxBoxes: number,
): Array<ClientDatumInfoBoxDataWithBounds<T>> {
  const boxData = getAllClientDatumInfoBoxes(data, maxBoxes);
  const layout = equalInfoBoxesLayout(baseLayout, boxData, lensIndex, previousLensIndex, {
    maxBoxHeight: 200,
  });
  return boxData.map(d => {
    const bounds = layout.boxArea(d.index, d.valence);
    return { ...d, bounds };
  });
}

function getAllClientDatumInfoBoxes<T extends ClientDatum>(
  data: T[],
  maxBoxesPerValence: number,
): Array<ClientDatumInfoBoxData<T>> {
  return [
    ...getClientDatumInfoBoxes(data, Valence.POSITIVE, maxBoxesPerValence),
    ...getClientDatumInfoBoxes(data, Valence.NEGATIVE, maxBoxesPerValence),
  ];
}
